(() => {
  if (!window.customElements || customElements.get('compact-cart-note')) return;
  customElements.define('compact-cart-note', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.onToggle = () => {
        if (this.details.open) this.querySelector('textarea-autosize')?.resizeInput?.();
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const drawer = this.closest('#dropdnMinicartPopup.minicart--compact');
          drawer?.querySelectorAll('.js-dropdn-content-scroll').forEach(element => {
            window.Scrollbar?.get(element)?.update();
          });
        });
      };
      this.details?.addEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      cancelAnimationFrame(this.frame);
    }
  });
})();
